export const PRESETS = {
  minWidth: 140,
  maxwidth: 200,
};
